import axios from "axios";
import { config } from "../config";

const API_URL = config.BACKEND_URL;

// Create axios instance with credentials (sends httpOnly cookies automatically)
export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptor to attach CSRF token on state-changing requests
apiClient.interceptors.request.use((config) => {
  if (config.method && ["post", "put", "delete", "patch"].includes(config.method)) {
    const csrfToken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("csrf_token="))
      ?.split("=")[1];
    if (csrfToken) {
      config.headers["X-CSRF-Token"] = decodeURIComponent(csrfToken);
    }
  }
  return config;
});

// Response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);
